import EventTimes from "@skrice.studio/mavia-common/build/models/main/EventTimes";
import { Breadcrumbs, Button, CardHeader, CircularProgress, Paper, Skeleton, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { withStyles } from "@mui/styles";
import axios from "axios";
import { createForm } from "rc-form";
import * as React from "react";
import { NavLink } from "react-router-dom";

import { Config } from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";

interface Props {
    activeUser: any;
    activeEnv: any;
    classes: any;
    form: any;
    history: any;
}

interface State {
    events: EventTimes[];
    loaded: boolean;
}

class GameEventsComponent extends React.Component<Props, State> {

    constructor(props) {
        super(props);

        this.state = {
            events: [],
            loaded: false,
        };

        document.title = Helpers.documentTitle("Game Events");
    }

    componentDidMount() {
        this.fetchData();
    }

    headers() {
        return {
            headers: { Authorization: Helpers.getSessionId() },
            timeout: 30000
        }
    }

    async enableAllEvents() {
        try {
            await axios.put(`${Config.getInstance.apiUrl}/api/game_events/enable_all`, {}, this.headers());
            PopupMessage.success("Events enabled!");

            this.fetchData();
        } catch (e) {
            PopupMessage.error(e.response.data.message);
        }
    }

    async fetchData() {
        try {
            const response = await axios.get(`${Config.getInstance.apiUrl}/api/game_events`, this.headers());
            this.setState({
                events: response.data,
                loaded: true,
            });
        } catch (e) {
            PopupMessage.error(e.response.data.message);
        }
    }

    formatType(value: string) {
        if (!value) {
            return "-";
        }

        return Helpers.capitalizeFirstLetter(value.replace("_", " "));
    }

    onRowClick(record) {
        this.props.history.push(`/game_events/${record.key}`);
    }

    displayRecords() {
        if (!this.state.loaded) {
            return <TableRow key="loading-row">
                <TableCell colSpan={7}>
                    {Helpers.renderSkeletonRows(5, 50)}
                </TableCell>
            </TableRow>
        }

        return this.state.events.map(record => (
            <TableRow key={"event-" + record.key} hover={true} onClick={() => this.onRowClick(record)} style={{ cursor: "pointer" }}>
                <TableCell>{record.key}</TableCell>
                <TableCell>{Helpers.getLocalizationName(record.name)}</TableCell>
                <TableCell>{record.enabled ? "Yes" : "No"}</TableCell>
                <TableCell>{record.start_at || "-"}</TableCell>
                <TableCell>{this.formatType(record.type)}</TableCell>
                <TableCell>{record.end_value || "-"}</TableCell>
                <TableCell>{record.grace_period || "-"}</TableCell>
            </TableRow>
        ));
    }

    renderAction() {
        if (Helpers.isProd()) {
            return null;
        }

        if (!this.state.loaded) {
            return <Skeleton width={145} height={50}/>
        }

        return <Button
            disableElevation
            color="primary"
            onClick={() => this.enableAllEvents()}
            variant="contained"
            size="small"
        >
            Enable all events
        </Button>;
    }

    render() {
        return (
            <div className="contentPadding">
                <Paper elevation={0}>
                    <CardHeader
                        title="Events"
                        action={this.renderAction()}
                    />
                    <Table className="min-table-size">
                        <TableHead>
                            <TableRow>
                                <TableCell>Key</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Enabled</TableCell>
                                <TableCell>Start</TableCell>
                                <TableCell>Type</TableCell>
                                <TableCell>End</TableCell>
                                <TableCell>Grace Period</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.displayRecords()}
                        </TableBody>
                    </Table>
                </Paper>
            </div>
        );
    }
}

const styles: any = theme => ({
    root: {
        width: "100%",
        marginTop: 24,
        overflow: "hidden",
    },
});

export const GameEvents = createForm()(withStyles(styles)(GameEventsComponent));
